import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { IMAGES } from '~/assets/assetsPath';
import styles from './DownloadApp.module.scss';
import { utilitiesApp } from '~/constants/utilitiesApp';

const cx = classNames.bind(styles);

const DownloadApp = () => {
    return (
        <div className={cx('wrapper')}>
            <Row align="middle">
                <Col xs={11}>
                    <Row className={cx('col_image')}>
                        <img src={IMAGES.ImageApp} alt="" style={{ width: '100%' }} />
                        {/* <img src={SVGS.ImageFashionMockup} alt="" style={{ width: '100%' }} /> */}
                    </Row>
                </Col>
                <Col xs={24} md={13}>
                    <Row className={cx('name_page')}>Scan code to download App</Row>
                    <Row className={cx('bio')}>
                        Beauty-ms is an application for scheduling, purchasing and synthesizing utilities on our store system
                        Beauty-ms store
                    </Row>
                    <Row className={cx('qr_code_section')}>
                        <div className={cx('qr_code')}>
                            <a href="https://vbeauty.app.link/download" target="blank">
                                <img src={IMAGES.QRCodeDownApp} alt="" />
                            </a>
                        </div>
                    </Row>
                    <Row className={cx('utilities_title')}>App Utilities</Row>
                    <Row className={cx('utilities_section')}>
                        {utilitiesApp?.map((item) => {
                            return (
                                <div className={cx('utilities_item')}>
                                    <div className={cx('icon')}>
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <div className={cx('title')}>{item.title}</div>
                                </div>
                            );
                        })}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default DownloadApp;
